import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {makeAction} from '../../redux/actions/makeAction';
import {
  FETCH_EARNINGS,
  FETCH_MINING_WORKERS,
  FETCH_STATS_POOL,
  FETCH_STATS_USER,
  PROFILE_FETCH,
} from '../../redux/actions/actionTypes';
import {getPoolHashrate, getUserHashrate} from '../../redux/selectors/stats';
import {isLoggedIn} from '../../redux/selectors/auth';
import {Col, Row} from 'antd';
import Hashrates from './dashboard/Hashrates';
import Earnings from './dashboard/Earnings';
import Miners from './dashboard/Miners';
import UserHashrateChart from './dashboard/UserHashrateChart';
import PoolHashrateChart from './dashboard/PoolHashrateChart';

class DashboardPage extends Component {
  componentDidMount() {
    this.props.fetchStatsPool();
    this.props.fetchStatsUser();
    this.props.fetchMiningWorkers();
    this.props.fetchEarnings();
    if (this.props.loggedIn) {
      this.props.fetchProfile();
    }
  }

  render() {
    return (
      <div className="container dashboard-widgets-wrapper">
        <Row className="dashboard-statistics-widgets-row" type="flex" justify="space-between">
          <Col xs={24} xl={8}>
            <Hashrates poolHashrate={this.props.poolHashrate} userHashrate={this.props.userHashrate} />
          </Col>
          <Col xs={24} xl={8}>
            <Earnings />
          </Col>
          <Col xs={24} xl={8}>
            <Miners />
          </Col>
        </Row>
        <Row gutter={20} style={{ marginTop: 20 }}>
          <Col xs={24} xl={12}>
            <UserHashrateChart />
          </Col>
          <Col xs={24} xl={12}>
            <PoolHashrateChart />
          </Col>
        </Row>
      </div>
    );
  }
}

DashboardPage.propTypes = {
  fetchStatsPool: PropTypes.func.isRequired,
  fetchStatsUser: PropTypes.func.isRequired,
  fetchMiningWorkers: PropTypes.func.isRequired,
  fetchEarnings: PropTypes.func.isRequired,
  fetchProfile: PropTypes.func.isRequired,
  poolHashrate: PropTypes.object,
  userHashrate: PropTypes.shape({
    current: PropTypes.number,
    dayAverage: PropTypes.number,
  }),
  loggedIn: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    poolHashrate: getPoolHashrate(state),
    userHashrate: getUserHashrate(state),
    loggedIn: isLoggedIn(state),
  };
};

const mapDispatchToProps = {
  fetchStatsPool: makeAction(FETCH_STATS_POOL),
  fetchStatsUser: makeAction(FETCH_STATS_USER),
  fetchMiningWorkers: makeAction(FETCH_MINING_WORKERS),
  fetchEarnings: makeAction(FETCH_EARNINGS),
  fetchProfile: makeAction(PROFILE_FETCH),
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// /src/components/pages/DashboardPage.jsx